import { ErrorData as HLSErrorData } from "hls.js"

export interface Player {
  videoElement: HTMLVideoElement
}

export type WebRTCServiceName = "hub" | "wheel"

interface VideoHandlerProps {
  onFatalError: (error: PlayerError) => void
  live: boolean
  autoPlay?: boolean
}

export interface RTCProps extends VideoHandlerProps {
  server: string
  webrtcService: WebRTCServiceName
  streamToken: string
  mobileSubtitles: boolean
}

export interface HLSProps extends VideoHandlerProps {
  manifestUrl: string
  mobileSubtitles: boolean
}

export type UrlPlayerProps = {
  url: string
  autoPlay?: boolean
}

// Messy combo of janus/portunus/hls.js errors
export type PlayerError =
  | {
      code?: PlayerErrorCode
    }
  | HLSErrorData

export enum PlayerErrorCode {
  WEBRTC_NOT_SUPPORTED = "webrtc_not_supported",
  RECORDING_NOT_FOUND = "recording_not_found",
  REACHED_VIEWING_CAPACITY = 460, // https://github.com/meetecho/janus-gateway/blob/326b00c5b5184d6bafb4630669c49ef03be4f4ef/apierror.h#L44
}
